// Celular da conta: só do Brasil (+55), DDD da lista da Anatel e 9 dígitos começando por 9. Guardado só com os
// dígitos e o 55 na frente (5511987654321). Sem código de confirmação: o número é conferido só no formato. Usado pelo
// jogo (máscara e validação antes de enviar) e pela API (a validação que vale).

// Os 67 DDDs em uso no Brasil, pela Anatel.
export const DDDS: ReadonlySet<number> = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19,
  21, 22, 24, 27, 28,
  31, 32, 33, 34, 35, 37, 38,
  41, 42, 43, 44, 45, 46, 47, 48, 49,
  51, 53, 54, 55,
  61, 62, 63, 64, 65, 66, 67, 68, 69,
  71, 73, 74, 75, 77, 79,
  81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

// Aceita "(11) 98765-4321", "11987654321", "+55 11 98765-4321" e "5511987654321". Recusa fixo (8 dígitos), DDD que
// não existe, número curto e outro país (um "+" que não seja +55). Devolve "5511987654321" ou null.
export function normalizarCelular(entrada: unknown): string | null {
  if (typeof entrada !== 'string' || entrada.length > 30) return null;
  const texto = entrada.trim();
  if (texto.startsWith('+') && !/^\+\s*55/.test(texto)) return null;
  let d = texto.replace(/\D/g, '');
  if (d.length === 13 && d.startsWith('55')) d = d.slice(2);
  if (d.length !== 11 || !DDDS.has(Number(d.slice(0, 2))) || d[2] !== '9') return null;
  return '55' + d;
}

// 5511987654321 vira "(11) 98765-4321".
export function formatarCelular(numero: string): string {
  const d = numero.replace(/^55/, '');
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

// O número mascarado que o admin vê: "(11) 9••••-4321".
export function mascararCelular(numero: string): string {
  const d = numero.replace(/^55/, '');
  return `(${d.slice(0, 2)}) ${d[2]}••••-${d.slice(-4)}`;
}

// A máscara enquanto a pessoa digita: "11987" vira "(11) 987", até "(11) 98765-4321". Um 55 colado na frente sai.
export function mascararDigitando(texto: string): string {
  let d = texto.replace(/\D/g, '');
  if (d.length > 11 && d.startsWith('55')) d = d.slice(2);
  d = d.slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : '';
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}
